var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m13.886 16 7.057-7.057a1.333 1.333 0 1 0-1.886-1.886l-8 8c-.52.52-.52 1.365 0 1.886l8 8a1.333 1.333 0 1 0 1.886-1.886L13.886 16z","fill":_vm.color,"fill-rule":"nonzero"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }